<div class="wrapper">
	<!--*ngIf="$clientTranslationKeysObservable | async as config"-->
	<mat-toolbar>
		<div fxFill fxLayout="row" fxLayoutAlign="start space-between">
			<div class="tool-title" fxLayout="column" fxFlex="60">
				{{ TOOL_TITLE }}
				<div fxLayout="row" fxFlex="20">
					<a id="translation-manager-toggle-key-pane-button" (click)="actionSideNav.toggle()">
						<i class="fa-solid fa-bars"></i>
						Toggle Key Pane
					</a>
				</div>
			</div>

			<div fxFlex="40" fxLayout="row" fxLayoutAlign="end start" fxLayoutGap="20px">
				<button
					id="translation-manager-add-new-key-button"
					class="translate-all-button"
					fxFlexAlign="end"
					mat-raised-button
					[disabled]="!ALLOW_NEW_KEY_CREATION"
					(click)="openNewKeyCreationModal()"
				>
					Add New Key
				</button>
				<button
					id="translation-manager-translate-all-button"
					class="translate-all-button"
					fxFlexAlign="end"
					mat-raised-button
					[disabled]="!ALLOW_TRANSLATION_AUTOMATION"
					(click)="translateAllKeysByLanguage()"
				>
					Translate All Keys
				</button>
				<button
					id="translation-manager-refesh-data-button"
					class="translate-all-button"
					fxFlexAlign="end"
					mat-raised-button
					(click)="refreshTranslationStore()"
				>
					Refresh Data
				</button>
			</div>
		</div>
	</mat-toolbar>

	<mat-sidenav-container id="sidenav-container" autosize>
		<mat-sidenav #actionSideNav opened mode="side" position="start" [opened]="true" class="translation-key-panel">
			<client-translation-key-panel #clientTranslationKeyPanel></client-translation-key-panel>
		</mat-sidenav>

		<client-translation-admin-pane
			#clientTranslationAdminPane
			*ngIf="clientTranslationKeyPanel.selectedTranslationKey"
			[clientTranslationKey]="this.clientTranslationKeyPanel.selectedTranslationKey"
		>
		</client-translation-admin-pane>
	</mat-sidenav-container>
</div>
